export default [
  {
    path: 'require',
    name: 'require',
    props: true,
    meta: {
      allowAnonymous: true
    },
    component: resolve => {
      require(['modules/personal/Print3D/Require'], resolve)
    }
  },
  {
    path: 'mycart',
    name: 'mycart',
    meta: {
      allowAnonymous: true
    },
    component: resolve => {
      require(['modules/personal/Print3D/MyCart'], resolve)
    }
  },
  {
    path: 'inquiry',
    name: 'inquiry',
    props: true,
    meta: {
      canSimpleReg: true
    },
    component: resolve => {
      require(['modules/personal/Print3D/Inquiry'], resolve)
    }
  },
  {
    path: 'payment/:id',
    name: 'payment',
    component: resolve => {
      require(['modules/personal/Print3D/Payment'], resolve)
    }
  },
  {
    path: 'produce/:id',
    name: 'produce',
    component: resolve => {
      require(['modules/personal/Print3D/Produce'], resolve)
    }
  },
  {
    path: 'delivery/:id',
    name: 'delivery',
    component: resolve => {
      require(['modules/personal/Print3D/Delivery'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/process3D.js